import {
  FETCH_MINE_LISTINGS,
  FETCH_MINE_LISTINGS_SUCCESS,
  FETCH_MINE_LISTINGS_ERROR,
  FETCH_MINE_PARENTS,
  FETCH_MINE_PARENTS_SUCCESS,
  FETCH_MINE_PARENTS_ERROR,
  MineState,
  MineActionTypes,
} from './types';

const initialState: MineState = {
  listings: {
    loading: false,
    data: [],
  },
  parents: {
    loading: false,
    data: [],
  },
};

export default function mineReducer(
  state = initialState,
  action: MineActionTypes
): MineState {
  switch (action.type) {
    case FETCH_MINE_LISTINGS: {
      return {
        ...state,
        listings: {
          ...state.listings,
          loading: true,
        },
      };
    }
    case FETCH_MINE_LISTINGS_SUCCESS: {
      const { listings } = action;
      return {
        ...state,
        listings: {
          ...state.listings,
          loading: false,
          data: listings,
        },
      };
    }
    case FETCH_MINE_LISTINGS_ERROR: {
      return {
        ...state,
        listings: {
          ...state.listings,
          loading: false,
        },
      };
    }

    case FETCH_MINE_PARENTS: {
      return {
        ...state,
        parents: {
          ...state.parents,
          loading: true,
        },
      };
    }
    case FETCH_MINE_PARENTS_SUCCESS: {
      const { data } = action;
      return {
        ...state,
        parents: {
          ...state.parents,
          loading: false,
          data,
        },
      };
    }
    case FETCH_MINE_PARENTS_ERROR: {
      return {
        ...state,
        parents: {
          ...state.parents,
          loading: false,
        },
      };
    }
    default:
      return state;
  }
}
